import React from 'react';
import {connect} from "react-redux";
import {globalGetCoupons, globalGetPacketLogs} from "../redux/globalActions";

const Menu = ({global, actionGetPacketLogs, actionGetCoupons}) => {
    const selectedKio = (global.packetLogs&&global.packetLogs.kio)
        || (global.couponHistory&&global.couponHistory.kio)
        || "";

   return global.sims.map(sim => {
           return <div className={"card mt-2"+(sim.kio===selectedKio?" border-primary":"")}>
               <div className="card-body">
                   <nav className="nav float-right">
                       <a className="nav-link" href="#" onClick={_=>actionGetPacketLogs(sim.kio)}>使用量</a>
                       <a className="nav-link" href="#" onClick={_=>actionGetCoupons(sim.kio)}>追加</a>
                   </nav>
                   { sim.labelLocation=="" || <h5 className="card-title">{sim.labelLocation}</h5> }
                   <h5 className="card-title">{sim.labelSerial}</h5>
                   <h6 className="card-subtitle text-muted">データプラン {sim.dataPlan} | 残り {Math.round(sim.quota/100)/10}GB</h6>
               </div>
           </div>
       });
};

const mapState = state => ({
    global: state.global
});

const mapDispatch = dispatch => ({
    actionGetPacketLogs: (kio) => dispatch(globalGetPacketLogs(kio)),
    actionGetCoupons: (kio) => dispatch(globalGetCoupons(kio))
});

export default connect(mapState, mapDispatch)(Menu);
